// https://cmsdev.cruisecode.com/BookingPlatform/GetPickupLocation?CUID=72aca93d-62a8-48e8-abf5-9814dc7604ae&_=1694582877396

export const GetPickupLocation = [
    {
        PickupLocationID: 'PL-3',
        PickupLocationName: 'Base of Tram - Juneau, Alaska',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'PL-1',
        PickupLocationName:
            "Corner of 2nd and Broadway (National Park Service visitor's center)",
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'PL-2',
        PickupLocationName: 'Cruise Ship Dock - Juneau, Alaska',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'PL-4',
        PickupLocationName: 'Cruise Ship Dock - Skagway, Alaska',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'PL-9',
        PickupLocationName: 'Haines Test',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'PL-5',
        PickupLocationName: 'Skagway Office',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-1-1',
        PickupLocationName:
            'Pickup at dock - Carnival Cruise Lines : Carnival Freedom',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-1-50',
        PickupLocationName:
            'Pickup at dock - Carnival Cruise Lines : Carnival Luminosa',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-1-2',
        PickupLocationName:
            'Pickup at dock - Carnival Cruise Lines : Carnival Miracle',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-1-34',
        PickupLocationName:
            'Pickup at dock - Carnival Cruise Lines : Carnival Spirit',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-1-35',
        PickupLocationName:
            'Pickup at dock - Carnival Cruise Lines : Carnival Splendor',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-11-36',
        PickupLocationName:
            'Pickup at dock - Celebrity Cruises : Celebrity Eclipse',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-11-54',
        PickupLocationName:
            'Pickup at dock - Celebrity Cruises : Celebrity Edge',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-11-37',
        PickupLocationName:
            'Pickup at dock - Celebrity Cruises : Celebrity Millennium',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-11-38',
        PickupLocationName:
            'Pickup at dock - Celebrity Cruises : Celebrity Solstice',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-11-53',
        PickupLocationName:
            'Pickup at dock - Celebrity Cruises : Celebrity Summit',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-3-19',
        PickupLocationName: 'Pickup at dock - Cunard Line : Queen Elizabeth',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-14-52',
        PickupLocationName: 'Pickup at dock - Disney : Disney Miracle',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-14-47',
        PickupLocationName: 'Pickup at dock - Disney : Disney Wonder',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-7',
        PickupLocationName: 'Pickup at dock - Holland America Line : Eurodam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-9',
        PickupLocationName:
            'Pickup at dock - Holland America Line : Koningsdam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-11',
        PickupLocationName:
            'Pickup at dock - Holland America Line : Nieuw Amsterdam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-12',
        PickupLocationName: 'Pickup at dock - Holland America Line : Noordam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-32',
        PickupLocationName: 'Pickup at dock - Holland America Line : Oosterdam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-45',
        PickupLocationName: 'Pickup at dock - Holland America Line : Volendam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-46',
        PickupLocationName: 'Pickup at dock - Holland America Line : Westerdam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-55',
        PickupLocationName: 'Pickup at dock - Holland America Line : Zaandam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-4-28',
        PickupLocationName: 'Pickup at dock - Holland America Line : Zuiderdam',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-13',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Bliss',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-14',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Encore',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-56',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Jade',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-15',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Jewel',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-31',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Joy',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-41',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Spirit',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-5-16',
        PickupLocationName:
            'Pickup at dock - Norwegian Cruise Line : Norwegian Sun',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-6-30',
        PickupLocationName: 'Pickup at dock - Oceania Cruises : Insignia',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-6-21',
        PickupLocationName: 'Pickup at dock - Oceania Cruises : Regatta',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-3',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Coral Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-39',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Crown Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-5',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Discovery Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-6',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Emerald Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-8',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Grand Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-10',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Majestic Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-22',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Royal Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-23',
        PickupLocationName: 'Pickup at dock - Princess Cruises : Ruby Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-7-24',
        PickupLocationName:
            'Pickup at dock - Princess Cruises : Sapphire Princess',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-8-26',
        PickupLocationName:
            'Pickup at dock - Regent Seven Seas Cruises : Seven Seas Explorer',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-8-27',
        PickupLocationName:
            'Pickup at dock - Regent Seven Seas Cruises : Seven Seas Mariner',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-9-49',
        PickupLocationName:
            'Pickup at dock - Royal Caribbean International : Brilliance of the Seas',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-9-40',
        PickupLocationName:
            'Pickup at dock - Royal Caribbean International : Enchantment of the Seas',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-9-17',
        PickupLocationName:
            'Pickup at dock - Royal Caribbean International : Ovation of the Seas',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-9-18',
        PickupLocationName:
            'Pickup at dock - Royal Caribbean International : Quantum of the Seas',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-9-20',
        PickupLocationName:
            'Pickup at dock - Royal Caribbean International : Radiance of the Seas',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-9-25',
        PickupLocationName:
            'Pickup at dock - Royal Caribbean International : Serenade of the Seas',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-10-33',
        PickupLocationName: 'Pickup at dock - Seabourn : Seabourn Odyssey',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-12-42',
        PickupLocationName: 'Pickup at dock - Silversea Cruises : Silver Muse',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-12-51',
        PickupLocationName: 'Pickup at dock - Silversea Cruises : Silver Nova',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-12-43',
        PickupLocationName:
            'Pickup at dock - Silversea Cruises : Silver Shadow',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-12-44',
        PickupLocationName:
            'Pickup at dock - Silversea Cruises : Silver Whisper',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-16-57',
        PickupLocationName: 'Pickup at dock - testy cruises : Testy1',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-16-58',
        PickupLocationName: 'Pickup at dock - testy cruises : Testy2',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
    {
        PickupLocationID: 'CL-15-48',
        PickupLocationName: 'Pickup at dock - Viking Cruises : Orion',
        CompanyUniqueId: null,
        IsActive: null,
        CreatedDate: null,
        CreatedBy: null,
        LastModifiedDate: null,
        LastModifiedBy: null,
        latitude: null,
        longitude: null,
        MapFilePath: null,
        MapAddress: null,
        DefaultForNotArrivingByCruise: null,
        DefaultForArrivingByCruise: null,
    },
];
